<template>
    <div>
    <masternav/>
    <!--  -->
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
          <span class="navtext ">{{$t('contact_comp.nav1')}} </span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">{{$t('contact_comp.nav2')}}</span>
        </b-nav-item>
      </b-nav>
      <!--  -->
      <contactcomp/>
      <!--  -->
    <mainfooter/>
    </div>
</template>
<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'
import contactcomp    from '@/components/contactcomp.vue'
export default {
    name: 'Contact',
    metaInfo: {
      title: "Enterprise Panama - Contacto | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components:{
        masternav,
        mainfooter,
        maincontent,
        rents,
        contactcomp
    }
}
</script>
<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.supportside{
  background-color: rgb(235, 235, 235);
  
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.noline{
  text-decoration: none;
}
</style>